/**
 * NOTE: THIS DataStore CLASS IS IDENTICAL TO THE ONE IN mrtsclient EXCEPT THAT IT DOES NOT EXTEND
 * WATCHABLE OBJECT. FOR DETAILS, SEE:
 *  #162 Prepare DataStore to be externalized to mrtsclient
 *  https://playmegaphone.unfuddle.com/a#/projects/36870/tickets/by_number/162
 */

/**
 * Stores data loaded by the client either through MRTSConnection or through other services.
 * The DataStore provided in the mrtsclient library defines the format required for all client
 * DataStore objects, but the DataStore is not instantiated by the mrtsclient library. Instead,
 * the client is expected to instantiate DataStore (or a DataStore subclass), and pass the
 * instantiated object to MRTSConnection.
 */
export class DataStore {
  constructor () {
    this.environment = null;
    this.studioSessionToken = null;
    this.megaphoneToken = null;
    this.mrtsEndpoint = null;
    this.deploymentID = null;
    this.deploymentKey = null;
    this.deploymentPassword = null;
    this.instanceID = null;
    this.deploymentSettings = null;
    this.themeSets = null;
    this.themeSetsMissingFromProject = new Map();      // ThemeSets not available in the current project
    this.idsOfThemeSetsMissingFromSystem = new Set();  // IDs of ThemeSets not available in Studio at all
                                                       // (likely because the ThemeSet was deleted).
    this.themes = null;
    this.playlist = null;
    this.webpolls = new Map();
    this.rankings = new Map();
  }

  log () {
    console.warn('\n=================================================\n '
      + ' DataStore (Evaluated on Expansion)'
      + '\n=================================================\n'
      + 'IMPORTANT: The DataStore below is NOT a frozen snapshot. It is a LIVE reflection of the '
      + 'current state of all objects in the DataStore AT THE TIME YOU EXPAND IT IN THE LOG! '
      + 'For a frozen snapshot of the DataStore, use logClone() instead.',
      this);
  }


  logClone () {
    console.warn('\n=================================\n '
      + ' DataStore (Frozen)'
      + '\n=================================\n'
      + 'IMPORTANT: The DataStore below is a frozen snapshot of the DataStore at the time this message '
      + 'was logged. It is NOT updated by the browser\'s dev tools when you expand it.\n',
      JSON.parse(JSON.stringify(this)),
      '\n=================================\n\n');
  }
}
